export default __webpack_public_path__ + "static/media/discount image.07142bcb.png";